<template>
<div>

		<v-layout row align-center class="mx-2 py-1">
			<v-btn
				small
				color="primary color--text text-none"
				class="ml-0"
				@click="show_filters = !show_filters; ">
				<v-icon
					:class="show_filters ? 'left-turn' : 'right-turn'"
					class="mr-2">
					filter_list
				</v-icon>
				Filtres
				<span class="btn-label">
					ESC
				</span>
			</v-btn>
			<FiltersChips
				:filters="filters"
				@search="search()">
			</FiltersChips>
			<v-spacer></v-spacer>
			<v-chip
				label
				v-if="!loading"
				color="background darken-1"
				:class="{ 'warning--text text--lighten-1': results.length === 10000 }"
				class="ml-2">
				{{ results.length }} Asset
				<span v-if="results.length > 1">s</span>
			</v-chip>
			<v-btn
				small flat icon
				color="primary"
				:loading="loading"
				@click="search()">
				<v-icon>refresh</v-icon>
			</v-btn>
		</v-layout>

		<div class="d-flex">
			<v-scroll-x-transition :hide-on-leave="true" :duration="40">
				<Filters
					v-show="show_filters"
					:filters="filters"
					:show_filters="show_filters"
					:loading="loading"
					:nb_results="results.length"
					:uncomplete_query="uncomplete_query"
					@search="search()"
					@close="show_filters = false"
					@open="show_filters = true">
				</Filters>
			</v-scroll-x-transition>
			<div id="assets-table-top"></div>
			<div style="display: grid">
				<div id="assets-table" ref="assets-table"></div>
				<v-footer
					class="tabulator-footer"
					color="background darken-1"
					:height="50">
					<v-btn
						small flat
						color="primary"
						class="text-none"
						@click="onDataTreeClick()"
						:disabled="results.length === 0">
						<v-icon class="pr-1" v-if="suifa_tree">list</v-icon>
						<v-icon class="pr-1" v-else>view_list</v-icon>
						<div v-if="suifa_tree">
							Visualisation en liste
						</div>
						<div v-else>
							Visualisation par groupes Titre / Programme / Assets
						</div>
					</v-btn>
					<v-btn
						small flat
						color="primary"
						class="text-none"
						v-if="suifa_tree"
						@click="toggleGroups(true, false)"
						:disabled="results.length === 0">
						<v-icon class="pr-1">expand_more</v-icon>
						Déplier les titres
					</v-btn>
					<v-btn
						small flat
						color="primary"
						class="text-none"
						v-if="suifa_tree"
						@click="toggleGroups(true, true)"
						:disabled="results.length === 0">
						<v-icon class="pr-1">expand_more</v-icon>
							Déplier tout
					</v-btn>
					<v-btn
						small flat
						color="primary"
						class="text-none"
						v-if="suifa_tree"
						@click="toggleGroups(false, true)"
						:disabled="results.length === 0">
						<v-icon class="pr-1">expand_less</v-icon>
							Replier tout
					</v-btn>
					<div v-if="launcher_enabled" class="select-launch-btn">
						<div xs3 class="text-right">
							<v-menu offset-y :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-tooltip left color="background">
										<template v-slot:activator="{ on }">
											<v-btn
												flat icon
												:disabled="selected.length === 0"
												color="primary"
												class="mt-2 mr-0"
												v-on="on"
												@click="copyAssetsReferences()">
												<v-icon>content_copy</v-icon>
											</v-btn>
										</template>
										<span>Copier les références sélectionnées</span>
									</v-tooltip>
									<v-btn
										:disabled="selected.length === 0"
										color="primary color--text"
										class="text-none mt-2 mr-0"
										v-on="on">
										{{ selected.length }} Asset(s) Sélectionné(s)
									</v-btn>
									<v-btn
										v-if="!external_select_mode"
										:disabled="selected.length === 0"
										color="primary color--text"
										class="text-none mt-2 ml-0 mr-0"
										@click="directDDL(selected)">
										<v-icon class="mr-2">send</v-icon>
										Envoyer en DDL
									</v-btn>
								</template>
								<v-list dense class="background darken-1">
									<v-list-tile
										v-for="(item, i) in selected"
										:key="'selected' + i"
										@click="table.deselectRow(selected_rows[i])">
										<v-list-tile-avatar>
											<v-icon color="primary">check_box</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-content>
											<v-list-tile-title>
												{{ refs_mat[item] }}
											</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</v-menu>
						</div>
					</div>
					<div v-if="!launcher_enabled" class="select-launch-btn">
						<div v-if="multiselect">
							<v-menu offset-y top :close-on-content-click="false">
								<template v-slot:activator="{ on }">
									<v-tooltip left color="background">
										<template v-slot:activator="{ on }">
											<v-btn
												flat icon
												:disabled="selected.length === 0"
												color="primary"
												class="mt-2 mr-0"
												v-on="on"
												@click="copyAssetsReferences()">
												<v-icon>content_copy</v-icon>
											</v-btn>
										</template>
										<span>Copier les références sélectionnées</span>
									</v-tooltip>
									<v-btn
										:disabled="selected.length === 0"
										color="primary color--text"
										class="text-none mt-2 mr-0"
										v-on="on">
										{{ selected.length }} Asset(s) Sélectionné(s)
									</v-btn>
									<v-btn
										:disabled="selected.length === 0"
										color="primary color--text"
										class="text-none mt-2 ml-0 mr-0"
										@click="emitSelection()">
										<v-icon large>arrow_forward</v-icon>
									</v-btn>
								</template>
								<v-list dense class="background darken-1">
									<v-list-tile
										v-for="(item, i) in selected"
										:key="'selected' + i"
										@click="table.deselectRow(selected_rows[i])">
										<v-list-tile-avatar>
											<v-icon color="primary">check_box</v-icon>
										</v-list-tile-avatar>
										<v-list-tile-title>
											{{ refs_mat[item] }}
										</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
						</div>
						<div v-else>
							<v-flex grow>
								<v-btn
									:disabled="selected.length === 0"
									color="primary color--text"
									class="text-none mt-2 mr-0"
									@click="emitSelection()">
									<span v-if="selected[0]">
										{{ refs_mat[selected[0]] }}
									</span>
									<v-icon large right>arrow_forward</v-icon>
								</v-btn>
							</v-flex>
						</div>
					</div>
				</v-footer>
			</div>
		</div>

	<AssetDrawer
		v-if="asset_panel"
		:visible="asset_panel"
		:asset="asset"
		@close="asset = null; asset_panel = false">
	</AssetDrawer>

	<v-menu
		v-model="menu_show"
		:position-x="menu_x"
		:position-y="menu_y"
		:close-on-content-click="false"
		absolute
		dense
		offset-y>
		<v-list class="background darken-1">

			<v-list-tile
				@click="filters.search = menu_title; search()"
				:disabled="!menu_title">
				<v-list-tile-avatar>
					<v-icon>title</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>
					<div>
						Rechercher le titre
						<strong>"{{ menu_title }}"</strong>
					</div>
				</v-list-tile-title>
			</v-list-tile>

			<v-divider v-if="menu_t_aux_name" class="ma-0"></v-divider>

			<v-list-tile
				@click="filters.t_aux = menu_t_aux_code; search()"
				v-if="menu_t_aux_name">
				<v-list-tile-avatar>
					<v-icon>person</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>
					<div>
						Rechercher l'ayant-droit
						<strong>"{{ menu_t_aux_name }}"</strong>
					</div>
				</v-list-tile-title>
			</v-list-tile>

			<v-divider
				class="ma-0"
				v-if="menu_asset_id && launcher_enabled">
			</v-divider>

			<v-list-tile
				@click="$emit('show-launcher', {type: ['assetid', 'multi-assetid'], value: [menu_asset_id]}); menu_show = false"
				v-if="menu_asset_id && launcher_enabled">
				<v-list-tile-avatar>
					<v-icon>play_arrow</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>
					<div>
						Lancer une demande de travail depuis
						<strong>"{{ menu_asset_ref }}"</strong>
					</div>
				</v-list-tile-title>
			</v-list-tile>

			<v-divider
				class="ma-0"
				v-if="menu_asset_id && launcher_enabled">
			</v-divider>

			<v-menu v-if="menu_asset_id && launcher_enabled" offset-x right>
				<template v-slot:activator="{ on }">
					<v-list-tile v-on="on" @click="fetchAndFilterPrestations(menu_asset_type)">
						<v-list-tile-avatar>
							<v-icon>play_arrow</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>
								Lancer une prestation depuis
								<strong>"{{ menu_asset_ref }}"</strong>
							</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</template>
				<v-list class="background darken-1">
					<v-subheader v-if="prestations_loading">
						<v-progress-linear :height="1" :indeterminate="true">
						</v-progress-linear>
					</v-subheader>
					<v-subheader v-else-if="prestations_filtered.length === 0"
						class="subheading font-italic">
						Aucune prestation trouvée pour cet asset
					</v-subheader>
					<v-subheader v-else
						class="subheading">
						Prestations
					</v-subheader>
					<v-list-tile
						v-for="prestation in prestations_filtered"
						:key="prestation.id"
						:to="{
							name: 'Prestation',
							params: { id: 'new' },
							query: {
								jd_id: prestation.id,
								t_aux: menu_t_aux_code,
								babel_id: menu_babel_id,
								asset_ids: menu_asset_id
							}
						}">
						<v-list-tile-avatar>
							<v-icon>play_arrow</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>
								{{ prestation.label }}
							</v-list-tile-title>
							<v-list-tile-sub-title class="font-italic">
								{{ prestation.description }}
							</v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
			</v-menu>
		</v-list>
	</v-menu>

	<Loader :loading="loading"></Loader>
</div>
</template>

<script>
import formatters from '@/pages/filesystem/explorer_tabulator_formatters.js'
import AssetDrawer from '@/pages/filesystem/title_asset_finder_asset_drawer.vue'
import Filters from '@/pages/filesystem/title_asset_finder_filters.vue'
import FiltersChips from '@/pages/filesystem/title_asset_finder_filters_chips.vue'
import Loader from '@/components/loader.vue'
import Tabulator from 'tabulator-tables'
import 'tabulator-tables/dist/css/tabulator_midnight.min.css'
import { debounce } from 'debounce'
import { queryToFilters, filtersToQuery } from '@/pages/filesystem/title_asset_finder_filters.js'
export default {
	props: [
		'multiselect',
		'title',
		'customer_code',
		'asset_type',
		'behive_category',
		'babel_id',
		'babel_label',
		'return_file_paths',
		'return_objects',
		'launcher_enabled'
	],
	components: {
		AssetDrawer,
		Filters,
		FiltersChips,
		Loader
	},
	data () {
		return {
			show_filters: true,
			loading: false,
			filters: {
				search: null,
				ref_mat: null,
				t_aux: null,
				has_rv: 0,
				asset_type_clean: null,
				babel_id: null,
				origin: 0,
				behive_category: null,
				has_proxy: 0,
				ingest_date_after: null,
				ingest_date_before: null
			},
			results: [],
			refs_mat: {},
			selected: [],
			selected_rows: [],
			table: null,
			suifa_tree: true,
			asset: null,
			asset_panel: false,
			menu_show: false,
			menu_x: 0,
			menu_y: 0,
			menu_title: null,
			menu_asset_id: null,
			menu_asset_ref: null,
			menu_asset_type: null,
			menu_babel_id: null,
			menu_t_aux_name: null,
			menu_t_aux_code: null,
			asset_type_clean: null,
			prestations: [],
			prestations_loading: false,
			prestations_filtered: [],
			uncomplete_query: false
		}
	},
	computed: {
		external_select_mode () {
			return this.$route.query.select === '1' || false
		}
	},
	watch: {
		show_filters () {
			this.table.redraw(true)
		}
	},
	methods: {
		emitSelection () {
			if (this.return_file_paths) {
				let paths = []
				for (const selected_row of this.selected_rows) {
					if (!selected_row._row.data.locations) continue
					for (const location of selected_row._row.data.locations) {
						// 1 == Présent
						if (location.status === 1 && location.absolute_path) {
							if (location.absolute_path.toLowerCase().indexOf('/media/data') === 0) {
								paths.push({
									path: this.$paths.maestroToUNC(location.absolute_path)
								})
								break
							}
						}
					}
				}
				this.$emit('asset-selected', paths)
			} else if (this.return_objects) {
				let objects = this.selected_rows.map(row => row._row.data)
				this.$emit('asset-selected', objects)
			} else {
				this.$emit('asset-selected', this.selected.join(', '))
			}
		},
		directDDL (asset_ids) {
			this.$Bus.$emit('launcher', {
				jd_id: window.appConfig.maestro_wf['Direct DDL'].id,
				direct_edit: true,
				parameters: {
					asset_ids: asset_ids
				}
			})
		},
		copyAssetsReferences () {
			let refs = this.selected.map(id => this.refs_mat[id].replace(/_/g, '/'))
			let copied = this.$grv_clipboard.copyToClipboard(refs.join(','))
			if (copied) {
				this.$Toaster({
					title: `Copié`,
					content: refs.join('<br>'),
					type: 'success',
					loading: false,
					timeout: 1000
				})
			}
		},
		search () {
			this.results = []
			this.uncomplete_query = false
			this.refs_mat = {}
			for (const key in this.filters) {
				if (this.filters[key]) {
					if (typeof (this.filters[key]) === 'string') {
						this.filters[key] = this.filters[key].trim()
					}
				}
			}
			if (this.$route.name === 'Assets') {
				let query = filtersToQuery(this.filters)
				let route = {
					name: this.$route.name,
					query: query
				}
				this.$router.replace(route)
					.catch(error => {
						console.error(error.message)
					})
			}
			if (this.table) this.table.setData([])
			if (!this.filters.search &&
					!this.filters.babel_id &&
					!this.filters.ref_mat) {
				this.uncomplete_query = true
				if (!this.table) this.buildtable([])
				return
			}
			if (this.loading) return
			this.loading = true
			this.$EsMaestro.assets_search(this.filters)
				.then(results => {
					this.results = results
						.map(result => {
							this.$set(
								this.refs_mat,
								result._source.id,
								result._source.ref_material.replace(/\//g, '_')
							)
							result._source.isSelectable = true
							if (this.launcher_enabled) {
								if (!this.external_select_mode) {
									if (result._source.asset_size > 30e+9) {
										result._source.isSelectable = false
									}
								}
								if (['hot', 'catalog', 'nearline', 'cloud'].indexOf(result._source.behive_category) === -1) {
									result._source.isSelectable = false
								}
							}
							return result._source
						})
					if (this.table) {
						this.table.setData(this.results)
						if (results.length < 10) {
							this.table.setGroupStartOpen([true, true, true])
						} else {
							this.table.setGroupStartOpen([true, true, false])
						}
					} else {
						this.buildtable(this.results)
					}
				})
				.catch(error => {
					console.error(error)
					this.$EventDialer(
						'error',
						false,
						'Erreur',
						error.message,
						0
					)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onRowSelection (row, a) {
			row.reformat()
			this.updateMultiSelectorHtml()
		},
		onRowSelectionChanged (data, rows) {
			this.selected = data.map(item => item.id)
			this.selected_rows = rows
		},
		onMultiSelect (e) {
			e.stopImmediatePropagation()
			if (!this.multiselect) return
			let selectedRows = this.table.getSelectedRows()
			if (selectedRows.length > 0) {
				for (let i = 0; i < selectedRows.length; i++) {
					this.table.deselectRow(selectedRows[i])
				}
			} else {
				let rows = this.table.getRows()
				for (let i = 0; i < rows.length; i++) {
					this.table.selectRow(rows[i])
				}
			}
			// this.updateMultiSelectorHtml()
		},
		showMenu (e) {
			e.preventDefault()
			this.menu_show = false
			this.menu_x = e.clientX
			this.menu_y = e.clientY
			this.$nextTick(() => {
				this.menu_show = true
			})
		},
		fetchAndFilterPrestations (assetType) {
			this.prestations_filtered = []
			if (this.prestations.length === 0) {
				this.fetchPrestations(assetType)
			} else {
				this.filterPrestations(assetType)
			}
		},
		fetchPrestations (assetType) {
			this.prestations_loading = true
			this.$EsMaestro.jobdescriptor_prestation_list_light(true)
				.then(result => {
					this.prestations = result.map(jd => {
						jd.label = jd.label.replace('[Prestation] ', '')
						return jd
					}).sort((a, b) => {
						if (a.label < b.label) return -1
						if (a.label > b.label) return 1
						return 0
					})
					this.filterPrestations(assetType)
				})
				.catch(error => {
					console.error(error)
					this.$EventDialer('error', false, 'Erreur', error.message, 0)
				})
				.finally(() => {
					this.prestations_loading = false
				})
		},
		filterPrestations (assetType) {
			this.prestations_filtered = this.prestations.filter(presta => {
				if (!presta.storage.sources) return false
				let isCandidate = false
				for (let i = 0; i < presta.storage.sources.length; i++) {
					const source = presta.storage.sources[i]
					if (source.type === assetType.toLowerCase() ||
						source.type === 'any') {
						isCandidate = true
						break
					}
				}
				return isCandidate
			})
		},
		onDataTreeClick () {
			this.suifa_tree = !this.suifa_tree
			let cols = this.table.getColumns()
			const dynaCols = [
				'title.name',
				'program.type_prgm.lib_type_prgm',
				'program.serie.no_annee',
				'program.no_episode',
				'program.titre_epis_princ'
			]
			if (this.suifa_tree) {
				this.table.setGroupBy([
					'title.name',
					(data) => {
						let y = this.$commons.deepGet(data, 'program.serie.no_annee')
						if (y) {
							return `SAISON ${y} `
						}
						return data.program.type_prgm.lib_type_prgm
					},
					(data) => {
						let no_episode = this.$commons.deepGet(data, 'program.no_episode')
						let title_episode = this.$commons.deepGet(data, 'program.titre_epis_princ', '')
						if (no_episode) {
							return `EP ${no_episode} ${title_episode}`
						}
						let version = this.$commons.deepGet(data, 'program.version')
						if (version) {
							return `Version ${version} `
						}
						return 'Version non spécifiée'
					}
				])
				for (const col of cols) {
					if (dynaCols.indexOf(col.getField()) > -1) col.hide()
				}
			} else {
				this.table.setGroupBy(null)
				for (const col of cols) {
					if (dynaCols.indexOf(col.getField()) > -1) col.show()
				}
			}
			this.$nextTick(() => {
				this.table.redraw(true)
			})
		},
		toggleGroups (show, subgroups) {
			this.table.getGroups().forEach(group => {
				if (show) {
					setTimeout(() => group.show(), 0)
				} else {
					setTimeout(() => group.hide(), 0)
				}
				if (subgroups) {
					group.getSubGroups().forEach(subGroup => {
						if (show) {
							setTimeout(() => subGroup.show(), 0)
						} else {
							setTimeout(() => subGroup.hide(), 0)
						}
						if (subgroups) {
							subGroup.getSubGroups().forEach(subSubGroup => {
								if (show) {
									setTimeout(() => subSubGroup.show(), 0)
								} else {
									setTimeout(() => subSubGroup.hide(), 0)
								}
							})
						}
					})
				}
			})
		},
		buildtable (items) {
			let selectable = false
			if (this.multiselect) {
				selectable = true
			} else {
				selectable = 1
			}
			// let filters = queryToFilters(this.$route.query)
			let groupStartOpen = [true, true, true]
			if (items.length > 10) groupStartOpen = [true, true, false]
			let container = document.getElementById('assets-table-top')
			let topOffset = container.getBoundingClientRect().top
			topOffset += 50 // +50px = footer height
			let table = new Tabulator('#assets-table', {
				height: `calc(100vh - ${topOffset}px)`,
				data: items,
				index: 'id',
				layout: 'fitColumns',
				width: '100%',
				initialSort: [
					{column: 'ref_material', dir: 'desc'}
				],
				placeholder: '<span class="headline">0 Résultat</span>',
				reactiveData: true,
				resizableColumns: true,
				selectable: selectable,
				rowContext: (e, row) => {
					e.preventDefault()
					e.stopPropagation()
					let rowData = row.getData()
					this.menu_title = rowData.title.name
					this.menu_asset_id = rowData.id
					this.menu_asset_ref = rowData.ref_material
					this.menu_asset_type = rowData.type_sup.lib_type_sup
					this.menu_babel_id = this.$commons.deepGet(rowData, 'babel.id', null)
					this.menu_t_aux_name = rowData.t_aux.name
					this.menu_t_aux_code = rowData.t_aux.code
					this.showMenu(e)
				},
				groupContext: (e, group) => {
					e.preventDefault()
					e.stopPropagation()
					this.menu_title = null
					this.menu_asset_id = null
					this.menu_asset_ref = null
					this.menu_asset_type = null
					this.menu_babel_id = null
					this.menu_t_aux_name = null
					this.menu_t_aux_code = null
					if (group._group.level === 0) {
						this.menu_title = group._group.key
					} else if (group._group.level === 1) {
						this.menu_title = group._group.parent.key
					} else if (group._group.level === 2) {
						this.menu_title = group._group.parent.parent.key
					}
					this.showMenu(e)
				},
				groupToggleElement: 'header',
				groupStartOpen: groupStartOpen,
				groupHeader: [
					(value, count) => {
						let el = `${value}<span class="background--text text--lighten-5">`
						el += `(${count} asset`
						if (count > 1) el += 's'
						el += ')</span>'
						return el
					},
					(value, count) => {
						let el = `${value}<span class="background--text text--lighten-5">`
						el += `(${count} asset`
						if (count > 1) el += 's'
						el += ')</span>'
						return el
					},
					(value, count) => {
						let el = `${value}<span class="background--text text--lighten-5">`
						el += `(${count} asset`
						if (count > 1) el += 's'
						el += ')</span>'
						return el
					}
				],
				cellVertAlign: 'middle',
				columns: [
					{
						title: 'Référence',
						field: 'ref_material',
						width: 100,
						visible: true,
						tooltip: (cell) => {
							let rowData = cell.getRow().getData()
							return `REF: ${rowData.ref_material} | ${rowData.id}`
						},
						// hozAlign: 'center',
						cssClass: 'cell-btn',
						formatter: (cell) => {
							let ref = cell.getValue()
							return ref.replace(/\//g, '_')
						},
						cellClick: (e, cell) => {
							e.stopPropagation()
							let rowData = cell.getRow().getData()
							this.asset = rowData
							this.asset_panel = true
						}
					},
					{
						title: 'Ayant droit',
						field: 't_aux.name',
						// width: 180,
						visible: true,
						tooltip: (cell) => 'AYANT-DROIT: ' + cell.getValue(),
						formatter: (cell) => {
							return `<span class="cell-content-wrap">
								${cell.getValue()}
							</span>`
						}
					},
					{
						title: 'Titre',
						field: 'title.name',
						visible: false,
						tooltip: (cell) => 'TITRE: ' + cell.getValue(),
						formatter: (cell) => {
							return `<span class="cell-content-wrap">
								${cell.getValue()}
							</span>`
						}
					},
					{
						title: 'Programme',
						field: 'program.type_prgm.lib_type_prgm',
						widthShrink: 1,
						visible: false,
						tooltip: (cell) => {
							let type_pgm = cell.getValue()
							let labelArr = [type_pgm]
							let rowData = cell.getRow().getData()
							let version = this.$commons.deepGet(rowData, 'program.version')
							if (version) labelArr.push(version)
							return 'PGM: ' + labelArr.join(' - ')
						},
						formatter: (cell) => {
							let type_pgm = cell.getValue()
							let labelArr = [type_pgm]
							let rowData = cell.getRow().getData()
							let version = this.$commons.deepGet(rowData, 'program.version')
							if (version) labelArr.push(version)
							return `<span class="cell-content-wrap">
								${labelArr.join(' - ')}
							</span>`
						}
					},
					{
						title: 'Y',
						field: 'program.serie.no_annee',
						width: 60,
						visible: false,
						tooltip: (cell) => 'Y: ' + cell.getValue()
					},
					{
						title: '# Ep',
						field: 'program.no_episode',
						width: 100,
						visible: false,
						tooltip: (cell) => '# EP: ' + cell.getValue()
					},
					{
						title: 'Titre Ep',
						field: 'program.titre_epis_princ',
						widthShrink: 2,
						visible: false,
						tooltip: (cell) => 'TITRE EP: ' + cell.getValue(),
						formatter: (cell) => {
							return `<span class="cell-content-wrap">
								${cell.getValue() || ''}
							</span>`
						}
					},
					{
						title: 'Type',
						field: 'type_sup.lib_type_sup',
						tooltip: (cell) => 'TYPE: ' + cell.getValue(),
						width: 110,
						visible: true,
						formatter: (cell) => {
							return `<span class="cell-content-wrap">
								${cell.getValue()}
							</span>`
						}
					},
					{
						title: 'C',
						titleFormatter: () => {
							return `<i style="font-size: 18px;"
								class="v-icon material-icons">
								category
							</i>`
						},
						field: 'behive_category',
						hozAlign: 'center',
						visible: true,
						tooltip: (cell) => 'CATEGORIE: ' + cell.getValue(),
						width: 50,
						formatter: (cell) => {
							let category = cell.getValue()
							let color = 'white'
							let icon = 'help_outline'
							if (category === 'hot') {
								color = 'red'
								icon = 'whatshot'
							} else if (category === 'cold') {
								color = 'primary'
								icon = 'ac_unit'
							} else if (category === 'cloud') {
								color = 'teal'
								icon = 'cloud'
							} else if (category === 'nearline') {
								color = 'deep-purple'
								icon = 'dns'
							} else if (category === 'physical') {
								color = 'amber'
								icon = 'voicemail'
							} else if (category === 'data') {
								color = 'white'
								icon = 'save'
							} else if (category === 'deleted') {
								color = 'grey'
								icon = 'delete_forever'
							} else if (category === 'catalog') {
								color = 'info'
								icon = 'library_books'
							} else if (category === 'ingesting') {
								color = 'yellow'
								icon = 'input'
							} else if (category === 'legacy') {
								color = 'blue-grey'
								icon = 'archive'
							}
							return `<i
								style="font-size: 22px;"
								class="mr-1 v-icon material-icons ${color}--text">
								${icon}
							</i>`
						}
					},
					{
						title: 'Image',
						field: 'resume_detail.video',
						headerSort: false,
						widthGrow: 3,
						visible: true,
						tooltip: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							return 'IMAGE: ' + val.join(' - ')
						},
						formatter: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							// let el = '<span style="flex-wrap: wrap; display: flex; gap: 4px;">'
							let el = '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">'
							for (const tag of val) {
								let color = 'white'
								if (tag === 'SD') {
									color = 'grey lighten-1'
								} else if (tag === 'HD') {
									color = 'info accent-3'
								} else if (tag === '4K' || tag === 'UHD') {
									color = 'green accent-2'
								} else if (tag === 'DolbyVision' ||
														tag === 'HDR' ||
														tag === 'HDR10') {
									color = 'lime accent-3'
								}
								el += `<span
									class="v-chip ma-0 mr-1 v-chip--label v-chip--small ${color} color--text"
									style="max-height: 18px !important">
									<span
										class="v-chip__content px-1 font-weight-bold"
										style="max-height: 18px !important; padding: 0">
										${tag}
									</span>
								</span>`
							}
							el += '</span>'
							return el
						}
					},
					{
						title: 'Audio',
						field: 'resume_detail.audio',
						headerSort: false,
						visible: true,
						widthGrow: 3,
						tooltip: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							return 'AUDIO: ' + val.join(' - ')
						},
						formatter: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							// let el = '<span style="flex-wrap: wrap; display: flex; gap: 4px;">'
							let el = '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">'
							for (const tag of val) {
								el += `<span
									class="v-chip ma-0 mr-1 v-chip--label v-chip--small background lighten-3 color--text"
									style="max-height: 18px !important">
									<span
										class="v-chip__content px-1 font-weight-bold"
										style="max-height: 18px !important; padding: 0">
										${tag}
									</span>
								</span>`
							}
							el += '</span>'
							return el
						}
					},
					{
						title: 'Sous-titres',
						field: 'resume_detail.subtitle',
						headerSort: false,
						visible: true,
						tooltip: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							return 'ST: ' + val.join(' - ')
						},
						formatter: (cell) => {
							let val = cell.getValue()
							if (!Array.isArray(val)) return ''
							// let el = '<span style="flex-wrap: wrap; display: flex; gap: 4px;">'
							let el = '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;">'
							for (const tag of val) {
								el += `<span class="v-chip ma-0 mr-1 v-chip--label v-chip--small background darken-1 white--text"
									style="max-height: 18px !important">
									<span
										class="v-chip__content px-1 font-weight-bold"
										style="max-height: 18px !important; padding: 0">
										${tag}
									</span>
								</span>`
							}
							el += '</span>'
							return el
						}
					},
					{
						title: 'QC',
						field: 'has_rv',
						width: 54,
						tooltip: 'Voir le rapport sur Behive',
						hozAlign: 'center',
						cssClass: 'cell-icon-btn',
						visible: true,
						formatter: (cell) => {
							let has_rv = cell.getValue()
							let matId = cell.getRow().getData().id
							let url = `${window.appConfig._$ou3iju}dashboard/materials/${matId}/rv/`
							if (has_rv) {
								return `<a href="${url}" target="_blank">
									<i style="font-size: 24px;"
										class="v-icon material-icons success--text text--lighten-1">
										task_alt
									</i>
								</a>`
							}
							return ''
						}
					},
					{
						title: 'Observation',
						field: 'observation',
						visible: true,
						tooltip: (cell) => 'OBS: ' + cell.getValue(),
						formatter: (cell) => {
							return `<span class="cell-content-wrap">
								${cell.getValue()}
							</span>`
						}
						// width: 130
					},
					{
						title: 'Durée',
						field: 'duration',
						width: 76,
						visible: true,
						hozAlign: 'right',
						tooltip: (cell) => {
							return 'DUREE: ' + cell.getValue() || '-'
						},
						formatter: (cell) => {
							return cell.getValue() || '-'
						}
					},
					{
						title: 'Poids',
						field: 'asset_size',
						width: 76,
						visible: true,
						hozAlign: 'right',
						tooltip: (cell) => {
							return 'POIDS: ' + this.$weight.humanizeWeight(cell.getValue(), 1000)
						},
						formatter: (cell) => {
							return this.$weight.humanizeWeight(cell.getValue(), 1000)
						}
					},
					{
						title: 'Proxy',
						field: 'has_proxy',
						width: 66,
						visible: true,
						tooltip: 'Jouer le proxy sur Behive',
						hozAlign: 'center',
						cssClass: 'cell-icon-btn',
						formatter: (cell) => {
							let has_rv = cell.getValue()
							let matId = cell.getRow().getData().id
							let url = `${window.appConfig._$ou3iju}dashboard/materials/${matId}/`
							if (has_rv) {
								return `<a href="${url}" target="_blank">
									<i style="font-size: 24px;"
										class="v-icon material-icons success--text text--lighten-1">
										play_circle_outline
									</i>
								</a>`
							}
							return ''
						}
					}
				],
				selectableCheck: (row) => {
					return row.getData().isSelectable
				},
				rowSelected: this.onRowSelection,
				rowDeselected: this.onRowSelection,
				rowSelectionChanged: this.onRowSelectionChanged
			})
			if (selectable) {
				table.addColumn({
					field: 'selector',
					width: 40,
					headerHozAlign: 'center',
					hozAlign: 'center',
					visible: true,
					cssClass: 'select-cell',
					titleFormatter: () => {
						return formatters.headerSelector(false, this.multiselect)
					},
					formatter: formatters.selector,
					vertAlign: 'middle',
					headerSort: false,
					headerClick: this.onMultiSelect
				})
					.then(() => {
						table.moveColumn('selector', 'ref_material', false)
					})
					.catch(error => {
						console.error(error)
					})
			}
			if (this.suifa_tree) {
				table.setGroupBy([
					'title.name',
					(data) => {
						let y = this.$commons.deepGet(data, 'program.serie.no_annee')
						if (y) {
							return `SAISON ${y} `
						}
						return data.program.type_prgm.lib_type_prgm
					},
					(data) => {
						let no_episode = this.$commons.deepGet(data, 'program.no_episode')
						let title_episode = this.$commons.deepGet(data, 'program.titre_epis_princ', '')
						if (no_episode) {
							return `EP ${no_episode} ${title_episode}`
						}
						let version = this.$commons.deepGet(data, 'program.version')
						if (version) {
							return `Version ${version} `
						}
						return 'Version non spécifiée'
					}
				])
				table.setSort([
					{ column: 'title.name', dir: 'asc' },
					{ column: 'program.no_episode', dir: 'asc' },
					{ column: 'program.type_prgm.lib_type_prgm', dir: 'asc' },
					{ column: 'program.serie.no_annee', dir: 'asc' }
				])
			}
			this.table = table
		},
		updateMultiSelectorHtml: debounce(function () {
			let el = document.getElementById('multi-selector')
			if (!el) return
			let icon = 'check_box_outline_blank'
			let color = ''
			let selectedCount = this.table.getSelectedData().length
			if (selectedCount > 0) {
				color = 'primary--text'
				let tableData = this.table.getData()
				let selectableCount = 0
				for (let i = 0; i < tableData.length; i++) {
					if (tableData[i].isSelectable) selectableCount++
				}
				if (selectableCount === selectedCount) {
					icon = 'check_box'
				} else {
					icon = 'indeterminate_check_box'
				}
			}
			el.innerHTML = `
				<i style="font-size: 24px" class="v-icon material-icons ${color}">
					${icon}
				</i>
			`
		}, 60)
	},
	mounted () {
		this.filters = queryToFilters(this.$route.query)
		if (this.asset_type === 'video') {
			this.filters.asset_type_clean = 'Video'
		} else if (this.asset_type === 'subtitle') {
			this.filters.asset_type_clean = 'Sous-titre'
		} else if (this.asset_type === 'audio') {
			this.filters.asset_type_clean = 'Audio'
		} else if (this.asset_type === 'dcp') {
			this.filters.asset_type_clean = 'Package DCP'
		} else if (this.asset_type === 'imf') {
			this.filters.asset_type_clean = 'Package IMF'
		} else if (this.asset_type === 'imgseq') {
			this.filters.asset_type_clean = 'Sequence d\'image'
		} else if (this.asset_type === 'document') {
			this.filters.asset_type_clean = 'Document'
		} else {
			this.filters.asset_type_clean = null
		}
		if (this.title) this.filters.search = this.title
		if (this.customer_code) this.filters.t_aux = this.customer_code
		if (this.babel_id) this.filters.babel_id = this.babel_id
		if (this.behive_category) this.filters.behive_category = this.behive_category
		// setTimeout(() => {
		// 	this.buildtable([])
		// }, 100)
		this.search()
	}
}
</script>

<style lang="stylus" scoped>
.tabulator
	border: none
	background-color: transparent
	width: 100%
	max-width: 100%
	min-width: 100%
	font-size: 0.9em
	overflow: auto
	>>>.tabulator-tableHolder
		background-color: var(--v-background-base)
	>>>.tabulator-header
		// border-left: 1px solid var(--v-background-lighten1)
		border-top: 1px solid var(--v-background-lighten1)
		border-bottom: 1px solid var(--v-background-lighten1)
		background-color: var(--v-background-darken1)
		color: white !important
		.tabulator-col
			border-right: none
			background-color: var(--v-background-darken1) !important
			align-content: center
		.tabulator-col.select-cell
			cursor: pointer
			&:hover
				.v-icon
					color: var(--v-primary-base) !important
	>>>.tabulator-col-title
		font-weight: normal
		color: white !important
	>>>.tabulator-table
		background-color: var(--v-background-darken1)
		.tabulator-row
			background-color: var(--v-odd-base)
			// border-left: 1px solid var(--v-background-lighten1)
			border-bottom: 1px solid var(--v-background-lighten1)
			// height: 32px
			// min-height: 32px
			.tabulator-cell
				cursor: pointer
				border-right: none
				height: auto !important
				// line-height: 1.7
				// align-items: flex-start !important
				padding-top: 6px
				// min-height: 32px
				// height: 49px
				// display: inline-block !important
				overflow: hidden
				text-overflow: ellipsis
				max-width: 100%
				.tabulator-data-tree-branch
					border-color: white
			.tabulator-cell:hover
				.v-icon
					color: var(--v-primary-base)
				.v-icon.expander:hover
					color: var(--v-primary-base) !important
		.tabulator-row:hover
			background-color: rgba(255, 255, 255, 0.15) !important
			.tabulator-cell
				// background-color: var(--v-background-lighten1)
				// background-color: rgba(255, 255, 255, 0.1)
				background-color: transparent
		.tabulator-group
			color: white
			font-weight: normal
			border: none
			span
				color: white
			.tabulator-arrow
				border-left-color: white
				border-right-color: transparent
				border-bottom-color: transparent
				border-top-color: transparent
		.tabulator-group-level-0
			background-color: var(--v-background-darken2)
			border-bottom: 1px solid var(--v-background-lighten1)
			// border-left: 1px solid var(--v-background-lighten1)
			// border-right: 1px solid var(--v-background-lighten1)
		.tabulator-group-level-1
		.tabulator-group-level-2
			background-color: var(--v-background-darken1)
			border-bottom: 1px solid var(--v-background-lighten1)
			// border-left: 1px solid var(--v-background-lighten1)
			// border-right: 1px solid var(--v-background-lighten1)
		.tabulator-group-visible
			.tabulator-arrow
				border-left-color: transparent
				border-right-color: transparent
				border-bottom-color: transparent
				border-top-color: white

.darken-input
	.v-btn:not(.v-btn--active)
		opacity: 0.8
		color: white !important
	.v-btn.v-btn--active
		color: var(--v-color-base) !important
		background-color: var(--v-primary-base) !important

.v-list--disabled
	.v-icon
		color: hsla(0,0%,100%,.5)

.v-footer.tabulator-footer
	position: fixed
	bottom: 0
	width: 100%
	outline: 1px solid var(--v-background-lighten1)

>>>.v-input--checkbox
	label
		margin: 0 !important
		color: white
>>>.v-input--checkbox.v-input--is-label-active
	label
		color: var(--v-primary-base)

.left-turn
	transform: rotate(90deg)

.right-turn
	transform: rotate(-90deg)

.select-launch-btn
	position: fixed
	right: 10px

// >>>.cell-content-wrap
// 	max-width: 100%
// 	text-wrap-mode: wrap
// 	overflow-wrap: break-word

>>>.cell-btn
	color: var(--v-primary-base)
	padding-left: 6px
	&:hover
		background-color: var(--v-primary-base) !important
		color: var(--v-color-base)

>>>.cell-icon-btn
	padding: 0px !important
	a
		height: 100%
		width: 100%
	.v-icon
		height: 100%
		width: 100%
		padding-top: 4px
		&:hover
			background-color: var(--v-primary-base) !important
			color: var(--v-color-base) !important

</style>



// WEBPACK FOOTER //
// src/pages/filesystem/title_asset_finder.vue